<template>
  <div id="app">
    <keep-alive>
      <!-- 这里是会被缓存的视图组件-->
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/App.vue